import { GET_ORG_CONTACTS, UPDATE_ORG_CONTACTS } from '../../types'

const initialState = {
  accountAdministrator: '',
  billingContact: '',
  technicalContact: '',
  availableContacts: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORG_CONTACTS: return {
      ...state,
      accountAdministrator: action.payload.accountAdministrator,
      billingContact: action.payload.billingContact,
      technicalContact: action.payload.technicalContact,
      availableContacts: action.payload.availableContacts
    }
    case UPDATE_ORG_CONTACTS: return {
      ...state,
      accountAdministrator: action.payload.accountAdministrator,
      billingContact: action.payload.billingContact,
      technicalContact: action.payload.technicalContact
    }
    default: return { ...state }
  }
}
